import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full px-4 md:px-6 py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20geometric%20background%20with%20soft%20amber%20and%20coral%20gradients%2C%20stylized%20modern%20illustration%2C%20smooth%20flowing%20shapes%2C%20minimalist%20design%2C%20clean%20and%20inviting%20atmosphere%2C%20gentle%20warm%20light&width=1920&height=600&seq=cta-bg-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-accent-500/85"></div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
          准备好开启你的黄油网页游戏之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-xl mx-auto">
          数百款精选黄油网页游戏等你来探索，无需注册，打开浏览器即刻畅玩
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/role-playing"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white hover:bg-background-50 text-primary-600 font-semibold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-gamepad-line"></i>
            </div>
            立即畅玩
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 bg-transparent hover:bg-white/10 text-white border border-white/40 font-medium rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-heart-line"></i>
            </div>
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}